import { render, staticRenderFns } from "./Product_Gallery.vue?vue&type=template&id=d1512c60&scoped=true&"
import script from "./Product_Gallery.vue?vue&type=script&lang=js&"
export * from "./Product_Gallery.vue?vue&type=script&lang=js&"
import style0 from "./Product_Gallery.vue?vue&type=style&index=0&id=d1512c60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1512c60",
  null
  
)

export default component.exports